export default __webpack_public_path__ + "static/media/subscribe.b221d446.svg";